


import React from "react";
import styled from "styled-components";
import { BrandLogo } from "../../components/brandLogo";
import { Button } from "../../components/button";

import FarmingImg from "../../images/cancelamentoS.png";

import { Marginer } from "../../components/marginer";
import { deviceSize } from "../../components/responsive";
import { useMediaQuery } from "react-responsive";

const SpecialistAdContainer = styled.div`
  width: 100%;
  height: 660px;
  display: flex;
  background: rgb(254,254,254);
background: linear-gradient(90deg, rgba(254,254,254,1) 7%, rgba(232,233,227,1) 83%);
  align-items: center;
  justify-content: center;
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    flex-direction: column-reverse;
  }
`;

const SloganContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-right: 5em;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    align-items: center;
    margin: 0;
  }
`;

const Slogan = styled.h2`
  margin: 0;
  font-size: 24px;
  color: #fff;
  font-weight: 700;
  line-height: 1.3;
  text-align: start;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 20px;
  }
`;

const StandoutImage = styled.div`
  width: 45em;
  height: 29em;

  img {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 18em;
    height: 14em;
  }
`;

const SloganS = styled.div`

padding:17px;
font-size:40px;
color:#0000cc;
`


const SloganN = styled.div`
padding:17px;
font-size:11px;
color:#0000cc;
margin-bottom:-25px;



`


const SloganV = styled.div`
padding:17px;
font-size:11px;
color:#0000cc;
margin-bottom:-25px;



`


const SloganR = styled.div`
padding:17px;
font-size:11px;
color:#0000cc;
margin-bottom:50px;




`

const ButtonNice= styled.div`
background-color:#0000cc;
padding:13px;
margin-left:17px;
width:350px;
border-radius:36px;
color:#ffffff;
font-weight:bold;



`

export function Rodape(props) {
  const isMobile = useMediaQuery({ maxWidth: deviceSize.mobile });

  return (
    <SpecialistAdContainer>
      <ContentContainer>
        <SloganContainer>
         
          <Marginer direction="vertical" margin="1em" />
          <SloganContainer>
            <SloganS> Somos a Somatto Proteção Veicular </SloganS>
          </SloganContainer>
          <Marginer direction="vertical" margin="0.8em" />
        
        </SloganContainer>
        <StandoutImage>
          <img src={FarmingImg} alt="Rastreamento veicular somatto.org.br" />
        </StandoutImage>
      </ContentContainer>
    </SpecialistAdContainer>
  );
}
